import { css } from 'lit';
import componentStyles from '../../styles/component.styles';
export default css `
    ${componentStyles}

    :host {
        display: block;
        font-family: var(--sgdf-font-sans);
        color: var(--sgdf-color-default);
    }

    .header-title {
        font-size: 3rem;
    }

    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        @media (min-width: 700px) {
            height: 100px;
        }
    }

    .title {
        font-size: 2.5em;
        color: white;
        text-transform: uppercase;
    }

    .avatar {
        cursor: pointer;
    }

    .navbar::part(center) {
        padding: 0;
    }

    .right-buttons {
        display: flex;
        align-items: center;
        gap: var(--sgdf-spacing-small);
    }

    .big-container {
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: space-between;
        background-color: white;
    }
`;
//# sourceMappingURL=responsive-header.styles.js.map